
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import { faChevronDown, faChevronUp } from '@delfi.lt/fa-kit/icons/modules/classic/regular';
import { IconDefinition } from '@delfi.lt/fa-kit/icons/modules/icon-types';

interface Data {
  isExpanded: boolean;
  faChevronDown: IconDefinition;
  faChevronUp: IconDefinition;
}

interface Methods {
  toggle: () => void;
}

interface Computed {
  isVisible: boolean;
}

interface Props {
  article: ArticleData;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isExpanded: false,
      faChevronDown,
      faChevronUp,
    };
  },
  computed: {
    isVisible() {
      const { articleSummary } = this.article.content;

      return Boolean(articleSummary?.html && this.$store.state.piano.access.channelAccess);
    },
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;

      this.$event.send('link-click', {
        name: this.$t(this.isExpanded ? 'words.more' : 'words.less'),
        type: 'article-ai-summary',
      });
    },
  },
});
